import React, { useState, useEffect } from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import Navbar from '../Menus/Navbar'
import Footer from '../Menus/Footer'
import HOMEBANNER from '../images/TVBANNER.jpg'
import WASHINGMACHINE from '../images/TV.png'
import { FaQuestionCircle } from "react-icons/fa";
import CountUp from 'react-countup';
import { FaSmile, FaMapMarkedAlt, FaThumbsUp } from 'react-icons/fa';
import { useInView } from 'react-intersection-observer';
import './Home.css'
import AOS from 'aos';
import { FaCalendarAlt, FaClock, FaHeadset } from 'react-icons/fa';
// import 'aos/dist/aos.css';
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { motion } from "framer-motion";
import WASHWORK1 from '../images/tv.jpg';

import TL1 from "../images/TL1.jpg";
import TL2 from "../images/TL2.jpg";
import TL3 from "../images/TL3.jpg";
import TL4 from "../images/TL4.png";
import TL5 from "../images/TL5.jpg";
import TL6 from "../images/TL6.png";
import { FaPhoneAlt } from 'react-icons/fa';

export default function TVService() {





  const faqs = [
    {
      question: "What makes your TV service cost-effective?",
      answer: "Our TV service is budget-friendly due to our streamlined operations and expert technicians who fix issues efficiently without unnecessary replacements."
    },
    {
      question: "What is your policy on recurring TV issues?",
      answer: "If the same TV issue reappears within one month, we offer a free follow-up service to resolve it."
    },
    {
      question: "Do you provide a warranty on TV spare parts?",
      answer: "Yes, we offer a 3 to 6-month warranty on all TV spare parts depending on the part type and brand."
    },
    {
      question: "Can I check the TV parts before installation?",
      answer: "Absolutely. We show all spare parts to customers before installation to ensure trust and clarity."
    },
    {
      question: "How can I book a TV repair service?",
      answer: "You can contact us anytime — we are available 24/7 to schedule a convenient repair appointment."
    },
    {
      question: "What types of TV problems do you fix?",
      answer: "We repair screen issues, power failures, sound problems, port malfunctions, software issues, remote connectivity problems, and more."
    },
    {
      question: "Are your technicians experienced in TV repair?",
      answer: "Yes, our technicians are trained and experienced in repairing all types and brands of TVs, including LED, LCD, and Smart TVs."
    },
    {
      question: "Do you offer emergency TV repair services?",
      answer: "Yes, we provide urgent TV repair services when quick resolution is needed, such as during important events or functions."
    },
    {
      question: "How can I keep my TV in good condition?",
      answer: "Keep your TV dust-free, avoid power surges, and schedule regular servicing. Our technicians also provide tips during service visits."
    },
    {
      question: "What if I have more questions about TV service?",
      answer: "You can reach out to us anytime. Our support team is available to assist with all your TV-related concerns."
    }
  ];
  const tips = [
    {
      title: "Turn Off When Not in Use",
      content: "Turning off your TV when not in use helps save energy and extends the lifespan of the internal components."
    },
    {
      title: "Use a Voltage Stabilizer",
      content: "Protect your TV from voltage fluctuations by using a stabilizer or surge protector, especially in areas with unstable electricity."
    },
    {
      title: "Clean the Screen Gently",
      content: "Use a microfiber cloth to clean the screen. Avoid using harsh chemicals or applying pressure to prevent damage."
    },
    {
      title: "Ensure Proper Ventilation",
      content: "Keep the area around your TV well-ventilated to prevent overheating. Avoid placing it in closed cabinets without airflow."
    },
    {
      title: "Avoid Direct Sunlight",
      content: "Place the TV away from windows or direct sunlight, as excessive heat and UV rays can damage the screen and internal circuits."
    },
    {
      title: "Update TV Firmware",
      content: "Keep your Smart TV's software updated to enjoy the latest features, bug fixes, and improved performance."
    },
    {
      title: "Handle Remote with Care",
      content: "Avoid dropping the remote or spilling liquids on it. Keep extra batteries handy in case the remote stops working."
    },
    {
      title: "Check HDMI & Power Cables",
      content: "Ensure that cables are connected securely and not bent or frayed to maintain proper signal transmission and safety."
    },
    {
      title: "Use the Right Display Settings",
      content: "Adjust brightness, contrast, and picture mode according to your environment to enhance viewing experience and reduce strain."
    },
    {
      title: "Call a Technician for Screen or Sound Issues",
      content: "If your TV shows distorted images, no picture, or audio problems, call a professional to avoid further damage."
    }
  ];


  const accordionData = [
    {
      title: "TV Repair Services",
      content: "We handle all types of TV problems including no display, distorted sound, power issues, and panel faults with professional care."
    },
    {
      title: "TV Maintenance",
      content: "Regular maintenance keeps your TV running smoothly, extends its lifespan, and helps avoid costly repairs."
    },
    {
      title: "TV Installation",
      content: "We provide secure and professional installation for all types of TVs including LED, LCD, Smart TVs, and wall-mounted setups."
    },
    {
      title: "TV Troubleshooting",
      content: "Fast and precise diagnosis of common issues such as screen flickering, input lag, or connectivity problems."
    },
    {
      title: "TV Parts Replacement",
      content: "We replace damaged or faulty components such as LED panels, backlights, speakers, power boards, and more using genuine parts."
    }
  ];

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const toggleTip = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const services = [
    { title: "Tv Maintenance", desc: "Quick Diagnosis", img: TL2 },
    { title: "Tv Repairing", desc: "High-Quality Clean", img: TL1 },

    { title: "Tv Board Service", desc: "Preventive Maintenance", img: TL3 },
    { title: "Tv Visual issue", desc: "Picture Visible Issue", img: TL4 },
    { title: "Tv Speaker", desc: "Sound Quality & Repair", img: TL5 },
    { title: "Tv Service", desc: "Mother Board Service", img: TL6 },

  ];



  const [ref, inView] = useInView({ triggerOnce: true });

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    city: '',
    appliance: '',
    issue: ''
  });

  const handleChange = e => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    const { name, phone, city, appliance, issue } = formData;
    const message = `New Complaint:%0AName: ${name}%0APhone: ${phone}%0ACity: ${city}%0AAppliance: ${appliance}%0AIssue: ${issue}`;
    const whatsappURL = `https://wa.me/919342851992?text=${message}`; // Replace with your number
    window.open(whatsappURL, '_blank');
  };










  return (
    <>
      <Navbar />

      <section id="Banner-home" className="banner-home" style={{ backgroundImage: `url(${HOMEBANNER})` }}>
        <div className="banner-overlay">
          <div className="banner-container">
            {/* Left Side */}
            <div className="banner-left glass-effect">
              <h1 className="headline">TV Service Center</h1>
              <a href="tel:+9193428519926" className="call-btn">
                <FaPhoneAlt style={{ marginRight: '8px' }} />
                +919342851992
              </a>
            </div>

            {/* Right Side - Contact Form */}
            <div className="banner-right">
              <form className="contact-form" onSubmit={handleSubmit}>
                <input type="text" name="name" placeholder="Your Name" required onChange={handleChange} />
                <input type="tel" name="phone" placeholder="Phone Number" required onChange={handleChange} />
                <input type="text" name="city" placeholder="City" required onChange={handleChange} />
                <select name="appliance" required onChange={handleChange}>
                  <option value="">Select Appliance</option>
                  <option value="Washing Machine">Washing Machine</option>
                  <option value="Refrigerator">Refrigerator</option>
                  <option value="AC">AC</option>
                  <option value="TV">TV</option>
                </select>
                <textarea name="issue" placeholder="Tell us your issue..." required onChange={handleChange}></textarea>
                <button type="submit" className="submit-btn">Submit & Send to WhatsApp</button>
              </form>
            </div>
          </div>
        </div>
      </section>




      <section id="home-about">
        <div className="about-container">
          {/* Left Side */}
          <div className="about-left" data-aos="fade-left">
            <h2>About Our Company</h2>
            <h3>Home Appliance Assist</h3>
            <p>
              If your television isn’t turning on or shows screen/display issues, don’t worry. Contact us, and we’ll fix the problem promptly and professionally. We offer convenient, on-site TV repair services — just schedule a service call, and our technicians will come to your location. Or, visit us directly, and our skilled experts will resolve the issue efficiently. We provide reliable and expert TV services for all types and brands, including LED, LCD, Smart TVs, and Android TVs. With over <strong>8+ years</strong> of experience in the appliance service industry, Home Appliance Assist is committed to delivering top-quality service and complete customer satisfaction.
            </p>




            <img src={WASHINGMACHINE} alt='washing machine service' title='washing machine repair' className='img-fluid' />
          </div>

          {/* Right Side Boxes */}
          <div className="about-right">
            <h3>Issue In TV</h3>
            <div className="service-box" data-aos="fade-right" data-aos-delay="100">
              <p>TV Not Turning On</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="200">
              <p>No Picture or Black Screen</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="300">
              <p>No Sound Output</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="400">
              <p>TV Automatically Turning Off</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="500">
              <p>Lines or Patches on Screen</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="600">
              <p>Remote Control Not Working</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="700">
              <p>HDMI or AV Ports Not Responding</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="800">
              <p>Wi-Fi or Smart Features Not Working</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="900">
              <p>Power Supply or Adapter Issues</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="1000">
              <p>TV Requires Routine Maintenance</p>
            </div>



          </div>
        </div>
      </section>



      <section id="washing-machine-service" className="washing-service-section">
        <h2 className="section-title">What We Do for TV Service</h2>
        <div className="washing-service-grid">
          {services.map((service, index) => (
            <motion.div
              className="washing-card"
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <img src={service.img} alt={service.title} className="washing-img" />
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      <section id="washing-accordion-section" className="accordion-wrapper">
        <div className="accordion-container">
          <div className="accordion-image">
            <img src={WASHWORK1} alt="Washing Machine Service" />
          </div>
          <div className="accordion-content">
            <h2>TV Service Details</h2>
            {accordionData.map((item, index) => (
              <div className="accordion-item" key={index}>
                <div
                  className={`accordion-title ${activeIndex === index ? "active" : ""}`}
                  onClick={() => toggleAccordion(index)}
                >
                  <h3>{item.title}</h3>
                  <span>{activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}</span>
                </div>
                <div
                  className={`accordion-body ${activeIndex === index ? "open" : ""}`}
                >
                  <p>{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/*    
     <section id="desc" className="service-section">
       <div className="service-item" data-aos="fade-right">
         <div className="service-text">
           <h2>Washing Machine Issues?</h2>
           <p>
             Is your washing machine making noise, not spinning, or leaking water? Don’t worry — our trained experts diagnose and fix all issues quickly. 
             We offer <strong>same-day doorstep service</strong> to get your appliance back up and running smoothly.
           </p>
           <a href="/washing-machine-service" className="service-btn">Fix Now</a>
         </div>
         <div className="service-image" data-aos="fade-left">
           <img src={WASHINGMACHINE} alt="Washing Machine Service" />
         </div>
       </div>
     
       <div className="service-item" data-aos="fade-right">
         <div className="service-text">
           <h2>AC Not Cooling?</h2>
           <p>
             Whether it's low cooling, water leakage, or unusual noise, our technicians provide <strong>same-day AC repair</strong> with expert diagnostics and professional care.
           </p>
           <a href="/ac-service" className="service-btn">Fix Now</a>
         </div>
         <div className="service-image" data-aos="fade-left">
           <img src={AC} alt="AC Service" />
         </div>
       </div>
     
       <div className="service-item" data-aos="fade-right">
         <div className="service-text">
           <h2>Fridge Not Working?</h2>
           <p>
             Experiencing cooling issues or strange noises? Let our experienced technicians help. We offer <strong>quick same-day service</strong> for all fridge problems.
           </p>
           <a href="/fridge-service" className="service-btn">Fix Now</a>
         </div>
         <div className="service-image" data-aos="fade-left">
           <img src={REF} alt="Fridge Service" />
         </div>
       </div>
     
       <div className="service-item" data-aos="fade-right">
         <div className="service-text">
           <h2>TV Not Turning On?</h2>
           <p>
             From screen issues to sound problems, we repair all types of TVs — LED, LCD, Smart TVs and more. Our <strong>same-day service</strong> ensures quick solutions.
           </p>
           <a href="/tv-service" className="service-btn">Fix Now</a>
         </div>
         <div className="service-image" data-aos="fade-left">
           <img src={TV} alt="TV Service" />
         </div>
       </div>
     </section>
     
     
  
     
      */}



      <section id="washing-tips-section" className="tips-wrapper">
        <div className="tips-container">
          <h2>TV Tips and Tricks</h2>
          <div className="tips-accordion">
            {tips.map((tip, index) => (
              <div className="tip-item" key={index}>
                <div className="tip-header" onClick={() => toggleTip(index)}>
                  <h3>{index + 1}. {tip.title}</h3>
                  <span>{activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}</span>
                </div>
                <div className={`tip-body ${activeIndex === index ? "open" : ""}`}>
                  <p>{tip.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      <section id="why-us" className="why-us-section">
        <div className="why-us-heading" data-aos="fade-up">
          <h2>Why Choose Us?</h2>
        </div>
        <div className="why-us-grid">
          <div className="why-us-card" data-aos="fade-right">
            <h3>Expert Technicians</h3>
            <p>Our team consists of certified experts with years of experience in appliance repairing and maintenance.</p>
          </div>
          <div className="why-us-card" data-aos="fade-left">
            <h3>Quick Service</h3>
            <p>We value your time and offer prompt service, ensuring your appliances are up and running in no time.</p>
          </div>
          <div className="why-us-card" data-aos="fade-right">
            <h3>Quality Assurance</h3>
            <p>We use genuine parts and provide a guarantee on our work, so you can trust in the quality of our service.</p>
          </div>
          <div className="why-us-card" data-aos="fade-left">
            <h3>Affordable Pricing</h3>
            <p>Our pricing is transparent and competitive, ensuring you get the best value for your money.</p>
          </div>
        </div>
      </section>

      <section id="impact" className="impact-section" ref={ref}>
        <h2 className="impact-heading" data-aos="fade-up">Our Impact in Numbers</h2>
        <div className="impact-container">
          <div className="impact-card" data-aos="fade-up" data-aos-delay="100">
            <FaSmile className="impact-icon" />
            <h2>{inView && <CountUp end={50000} duration={2} />}+</h2>
            <p>Happy Customers</p>
          </div>
          <div className="impact-card" data-aos="fade-up" data-aos-delay="200">
            <FaMapMarkedAlt className="impact-icon" />
            <h2>{inView && <CountUp end={60} duration={2} />}+</h2>
            <p>Areas Covered</p>
          </div>
          <div className="impact-card" data-aos="fade-up" data-aos-delay="300">
            <FaThumbsUp className="impact-icon" />
            <h2>{inView && <CountUp end={49000} duration={2} />}+</h2>
            <p>Satisfied Customers</p>
          </div>
        </div>
      </section>
      <section id="washing-faq-section" className="faq-section">
        <div className="faq-container">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            {faqs.map((faq, index) => (
              <div className="faq-card" key={index}>
                <div className="faq-icon">
                  <FaQuestionCircle />
                </div>
                <h3 className="faq-question">{faq.question}</h3>
                <p className="faq-answer">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="availability" className="availability-section">
        <h2 className="availability-heading" data-aos="fade-up">Our Availability</h2>
        <div className="availability-grid">
          <div className="availability-card" data-aos="fade-right">
            <FaCalendarAlt className="availability-icon" />
            <h3>Opening Day</h3>
            <p>
              Monday to Saturday <br />
              <span className="sunday-text">Sunday - Closed</span>
            </p>
          </div>
          <div className="availability-card" data-aos="fade-up">
            <FaClock className="availability-icon" />
            <h3>Office Available</h3>
            <p>9:00 AM to 9:00 PM</p>
          </div>
          <div className="availability-card" data-aos="fade-left">
            <FaHeadset className="availability-icon" />
            <h3>Customer Support</h3>
            <p>24/7 Available</p>
          </div>
        </div>
      </section>


      <section id="disclaimer" className="disclaimer-section" data-aos="fade-up">
        <div className="disclaimer-container">
          <div className="disclaimer-icon">
            <FaExclamationTriangle />
          </div>
          <div className="disclaimer-content">
            <h2>Disclaimer</h2>
            <p>
              Home Appliance Assist is an independent service provider offering expert repairing and maintenance services for a wide range of home appliances. We specialize in servicing all major home appliance types, including refrigerators, washing machines, air conditioners, and televisions.
            </p>
            <p>
              Please note that Home Appliance Assist is not affiliated with, endorsed by, or associated with any specific appliance manufacturers or brands. We do not use any brand names, trademarks, or logos on our website or in our promotional materials. All services provided are carried out by our team of experienced and certified technicians, independent of any manufacturer's certification.
            </p>
            <p>
              While we provide high-quality service for various appliance types, our services are not authorized by or affiliated with the manufacturers of the products we repair. Customers seeking manufacturer-authorized service and genuine parts should contact the official customer support of the respective brands.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>

  )
}
